export const NEWS_FEED = "Hover over the list of articles to pause scrolling";
export const MAP_FILTER = "Available regions are in dark grey";
export const CHART = "Click on any chart to enlarge it";
export const BOOKMARK =
  "Each Custom Report may have up to 10 Bookmarks from any report";
export const SHARE = "Reports shared with Team Members are read-only";
